export enum TaskStatuses {
  none = 'none',
  offered = 'task_offered',
  accepted = 'task_accepted',
  rejected = 'task_rejected',
  assigned = 'task_assigned',
  canceled = 'task_canceled',
  completed = 'task_completed',
}
